module.exports = __webpack_public_path__ + "assets/img/system-icon4.a281a6b5.png";